import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import _property from 'lodash/property';
import _identity from 'lodash/identity';

/**
 *
 * @param fieldIds: arrayOf(string)
 * returns a getter fn which is to be invoked with the universalMap
 *
 * e.g. const getter = createGetter([1,2]);
 * const universalMap = {1: 'foo', 2: 'bar', 3: 'foobar', 4: 'barfoo', 5: 'foofoo'};
 * const relevantMap = getter(universalMap); // {1: 'foo', 2: 'bar'}
 */
var createGetter = function createGetter(fieldIds) {
  return !fieldIds ? _identity : createSelector(fieldIds.map(_property), function generateFields() {
    for (var _len = arguments.length, fields = new Array(_len), _key = 0; _key < _len; _key++) {
      fields[_key] = arguments[_key];
    }
    // eslint-disable-line prefer-arrow-callback
    return fieldIds.reduce(function (fieldsMap, fieldId, index) {
      return Object.assign(fieldsMap, _defineProperty({}, fieldId, fields[index]));
    }, {});
  });
};
function createGetterForUnit(unit) {
  return createGetter(typeof unit !== 'string' && unit.fieldIds);
}
function createGetterFunctions(unitKey) {
  return createSelector(_property(unitKey), function generateGetterFuncs(data) {
    // eslint-disable-line prefer-arrow-callback
    return {
      valuesGetters: data.map(createGetterForUnit),
      warningsGetters: data.map(createGetterForUnit),
      errorsGetters: data.map(createGetterForUnit),
      fieldsGetters: data.map(createGetterForUnit)
    };
  });
}
export default function withGetters(unitKey) {
  return function wrapWithGetters(ComposedComponent) {
    return /*#__PURE__*/function (_PureComponent) {
      _inherits(WithGetters, _PureComponent);
      var _super = _createSuper(WithGetters);
      function WithGetters(props) {
        var _this;
        _classCallCheck(this, WithGetters);
        _this = _super.call(this, props);
        _this.getterFuncs = createGetterFunctions(unitKey);
        return _this;
      }
      _createClass(WithGetters, [{
        key: "render",
        value: function render() {
          var props = this.props;
          return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, this.props, this.getterFuncs(props)));
        }
      }]);
      return WithGetters;
    }(PureComponent);
  };
}